namespace $ {

	export class $shm_hitalama_file extends $giper_baza_entity.with({

		Size: $giper_baza_atom_real,

		File: $giper_baza_atom_link.to( ()=> $giper_baza_file ),

		// Storage: $giper_baza_atom_text,
		Tg_file_id: $giper_baza_atom_text,

	}){

		write_source_file?: File

		file_link() {
			return this.File()?.val() ?? null
		}

		file( next?: null | $giper_baza_file ) {
			return this.File(next)?.remote( next ) ?? null
		}

		file_ensure() {
			return this.File(null)?.ensure( this.land() ) ?? null
		}

		@ $mol_action
		tg_get_blob() {
			const botToken = $shm_hitalama_profile.current()!.secret_val('backup_bot_token')
			const fileId = this.Tg_file_id()?.val()

			const data: any = $mol_fetch.json( `https://api.telegram.org/bot${botToken.trim()}/getFile?file_id=${fileId}` )
			if( !data.ok ) {
				throw new Error(data.toString() || 'Не удалось получить информацию о файле')
			}

			const filePath = data.result.file_path
			const downloadUrl = `https://api.telegram.org/file/bot${botToken.trim()}/${filePath}`

			const blob = $mol_fetch.blob( downloadUrl )
			return blob
		}

		@ $shm_hitalama_process_wire_action
		tg_send_file( file: File ) {
			const file_id = this.Tg_file_id()?.val()
			if( file_id ) return file_id

			const profile = $shm_hitalama_profile.current()
			if( !profile ) return ''

			const botToken = profile.secret_val('backup_bot_token')
			const chatId = profile.secret_val('backup_chat_id')
			if( !botToken || !chatId ) return ''

			const formData = new ($mol_wire_sync(FormData))
			formData.append('chat_id', chatId.trim())
			formData.append('document', file, file.name)

			const data: any = $mol_fetch.json( `https://api.telegram.org/bot${botToken.trim()}/sendDocument`, {
				method: 'POST',
				body: formData
			})
			if (!data.ok) throw new Error(data.toString())
			
			const next_file_id = data.result.document.file_id
			this.Tg_file_id(null)?.val( next_file_id )
			return next_file_id
		}

		@ $shm_hitalama_process_wire_action
		tg_send_written_file() {
			const file = this.write_source_file
			if( !file ) return ''

			const file_id = this.Tg_file_id()?.val()
			if( file_id ) return file_id

			const profile = $shm_hitalama_profile.current()
			if( !profile ) return ''

			const botToken = profile.secret_val('backup_bot_token')
			const chatId = profile.secret_val('backup_chat_id')
			if( !botToken || !chatId ) return ''

			const formData = new ($mol_wire_sync(FormData))
			formData.append('chat_id', chatId.trim())
			formData.append('document', file, file.name)

			const data: any = $mol_fetch.json( `https://api.telegram.org/bot${botToken.trim()}/sendDocument`, {
				method: 'POST',
				body: formData
			})
			if (!data.ok) throw new Error(data.toString())
			
			const next_file_id = data.result.document.file_id
			this.Tg_file_id(null)?.val( next_file_id )
			return next_file_id
		}

		@ $shm_hitalama_process_wire_action
		baza_upload_file( file: Blob ) {
			const baza_file = this.file_ensure()
			if( !baza_file ) throw new Error( 'Failed to create baza file' )

			baza_file.blob( file )
			return baza_file.link().toString()
		}

		@ $shm_hitalama_process_wire_action
		baza_upload_written_file() {
			const file = this.write_source_file
			if( !file ) return ''

			const baza_file = this.file_ensure()
			if( !baza_file ) throw new Error( 'Failed to create baza file' )

			baza_file.blob( file )
			return baza_file.link().toString()
		}

		@ $mol_mem
		baza_upload_progress() {
			const link = this.file_link()
			if( !link ) return null
			return ( this.$.$giper_baza_glob.yard() as any ).send_progress_land?.( link.land() ) ?? null
		}

		baza_upload_progress_peek() {
			const link = this.file_link()
			if( !link ) return null
			return ( this.$.$giper_baza_glob.yard() as any ).send_progress_land?.( link.land(), false ) ?? null
		}

		@ $mol_action
		write( file: File ) {
			this.write_source_file = file
			this.title( file.name )
			this.Size(null)?.val( file.size )
			this.write_to_opfs( file )

			$mol_wire_async( this ).baza_upload_written_file().catch( ( error: unknown ) => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )

			$mol_wire_async( this ).tg_send_written_file().catch( ( error: unknown ) => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )
		}

		size() {
			return this.Size()?.val() ?? 0
		}

		opfs_name() {
			return this.link().toString()
		}

		opfs_exists_peek() {
			try {
				return $mol_wire_sync($shm_hitalama_file).fileExistsInOPFS( this.opfs_name() )
			} catch (error) {
				if( $mol_promise_like( error ) ) return false
				throw error
			}
		}

		@ $mol_mem
		baza_download_loaded() {
			const file = this.file()
			if( !file ) return 0

			try {
				return file.chunks().reduce( ( sum, chunk )=> sum + chunk.byteLength, 0 )
			} catch (error) {
				if( $mol_promise_like( error ) ) return 0
				throw error
			}
		}

		@ $mol_mem
		baza_download_progress() {
			if( this.opfs_exists_peek() ) return null
			this.$.$mol_state_time.now( 250 )

			const file = this.file()
			if( !file ) return null

			const loaded = this.baza_download_loaded()
			const total = this.size()
			const ratio = total ? Math.min( loaded / total, 1 ) : 0

			return {
				loaded,
				total,
				ratio,
				active: ratio < 1,
			}
		}

		@ $mol_mem
		blob() {
			const from_opfs = this.read_from_opfs()
			if( from_opfs ) return from_opfs

			const file = this.file()
			if( file ) {
				const progress = this.baza_download_progress()
				if( progress?.active ) this.$.$mol_wait_timeout( 250 )

				const total = this.size()
				const blob = file.blob()
				if( total > 0 && blob.size !== total ) this.$.$mol_wait_timeout( 250 )
				if( total > 0 && !blob.size ) this.$.$mol_wait_timeout( 250 )

				this.write_to_opfs( blob )
				return blob
			}
			// if( this.Storage()?.val() != 'telegram' ) return this.file()?.blob()

			const blob = this.tg_get_blob()
			this.write_to_opfs( blob )
			return blob
		}

		@ $mol_mem
		text() {
			const blob = this.blob()
			if( !blob ) return ''

			const text = $mol_wire_sync(blob).text()
			return text
		}

		@ $mol_mem
		buffer() { //note it can be detached! by decodeAudioData for example
			const blob = this.blob()
			if( !blob ) return
			const buf = $mol_wire_sync(blob).arrayBuffer()
			return buf
		}

		async blob_uri_async() {
			const blob = this.blob()
			if( !blob ) return
			const uri = await $mol_blob_uri( blob )
			return uri
		}

		async blob_async() {
			const blob = await this.blob()
			return blob
		}

		@ $mol_action
		write_to_opfs( file: Blob ) {
			if( !file.size ) return

			$mol_wire_async( $shm_hitalama_file ).writeFileToOPFS( file, this.opfs_name() ).catch( error => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )
		}

		@ $mol_action
		read_from_opfs() {
			try {
				const file = $mol_wire_sync($shm_hitalama_file).readFileFromOPFS( this.opfs_name() )
				const total = this.size()
				if( file.size === 0 && this.file() ) {
					$mol_wire_async($shm_hitalama_file).deleteFileFromOPFS( this.opfs_name() ).catch( error => {
						if( !$mol_promise_like( error ) ) console.error( error )
					} )
					return null
				}
				if( total > 0 && file.size !== total ) {
					$mol_wire_async($shm_hitalama_file).deleteFileFromOPFS( this.opfs_name() ).catch( error => {
						if( !$mol_promise_like( error ) ) console.error( error )
					} )
					return null
				}
				return file
			} catch (error) {
				if( !$mol_promise_like( error ) ) return null
				throw error
			}
		}

		static async writeFileToOPFS( file: Blob, name: string ) {
			const root = await navigator.storage.getDirectory()
			const fileHandle = await root.getFileHandle( name, { create: true } )
			const writable = await fileHandle.createWritable()
			await writable.write( file )
			await writable.close()

			return fileHandle
		}

		static async readFileFromOPFS( fileName: string ) {
			const root = await navigator.storage.getDirectory()
			const fileHandle = await root.getFileHandle( fileName )
			const file = await fileHandle.getFile()
			return file
		}

		static async deleteFileFromOPFS( fileName: string ) {
			const root = await navigator.storage.getDirectory()
			await root.removeEntry( fileName )
		}

		static async fileExistsInOPFS( fileName: string ) {
			try {
				const root = await navigator.storage.getDirectory()
				await root.getFileHandle( fileName )
				return true
			} catch( error: any ) {
				if( error.name === 'NotFoundError' ) {
					return false
				}
				throw error
			}
		}
		
	}

}
